
interface CalendlyOptions {
    url: string;
}

declare global {
    interface Window {
        Calendly: {
            initPopupWidget: (options: CalendlyOptions) => void;
            closePopupWidget: () => void;
        };
    }
}

export const openCalendlyPopup = (url: string) => {
    // Check if Calendly is already loaded
    if (window.Calendly) {
        window.Calendly.initPopupWidget({ url });
        return;
    }

    // Load CSS
    if (!document.querySelector('link[href="https://assets.calendly.com/assets/external/widget.css"]')) {
        const link = document.createElement('link');
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    }

    // Load JS
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.onload = () => {
        // wait a brief moment for parsing
        setTimeout(() => {
            if (window.Calendly) {
                window.Calendly.initPopupWidget({ url });
            } else {
                console.error('Calendly script loaded but object not found');
            }
        }, 100);
    };
    script.onerror = () => {
        console.error('Failed to load Calendly script');
    };
    document.body.appendChild(script);
};
